<template>
  <div id="app">
    <meta name="referrer" content="never" /> <!--可以让img标签预加载网络图片-->
    <router-view />
  </div>
</template>

<script>

import { mapActions } from 'vuex'
export default {
  name: 'App',
  created() {
  },
  mounted() {
    // this.saveAreaList()
    // this.saveAtlasIndestryList()
  },
  methods: {
    // ...mapActions('industryMap', ['saveAreaList']),
    // ...mapActions('atlasMap', ['saveAtlasIndestryList'])
  }
}
</script>

<style lang="less">
@import '~@/styles/index.less';

@font-face {
  font-family: 'pingfang';
  src: url('./assets/font/font.ttf');
}


#app {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  // min-width: 1366px;/*no*/
  // min-height: 768px;/*no*/
  font-family: 'pingfang', 'Source Han Sans CN', Avenir, Helvetica, Arial, sans-serif !important;
  background-color: #030a2e !important;
  font-size: 12px;
}
</style>
